const React = require('react');
const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const toLower = require('mn-utils/toLower');

const {backLocation} = require('../../../../router');

const WrapperWithLoading = require('../../../dumb/WrapperWithLoading/B');
const Caption = require('../../../dumb/Caption/C');

const withState = require('../../../../utils/withState');
const {apiV2InvoiceGet} = require('../../../../api/merchant/invoiceHistory');

const DataDisplay = require('./DataDisplay');
const QuotesTable = require('./QuotesTable');
const {account$} = require('../../../../emitters/account');
const ButtonBack = require('../../../dumb/Button/BackB');

module.exports = withState((setState) => {
  let _id;
  let _cancel = noop;

  function update() {
    _cancel();
    _cancel = delay(() => {
      setState({
        loading: true,
      });
      _cancel = apiV2InvoiceGet({
        id: _id,
      }).finally((error, response) => {
        setState({
          data: response || {},
          loading: false,
        });
      }).cancel;
    });
  }

  return (state, props) => {
    const params = props.params || {};
    const id = params.id;
    const data = state.data || {};
    const status = toLower(data.state || '');

    _id === id || update(_id = id);

    return (
      <WrapperWithLoading
        className={'wmin270 wmax1000 ' + (props.className || '')}
        loading={state.loading}
      >
        <div className="layoutRow jcSB aiC dB@m">
          <div className="layoutRow aiC">
            <ButtonBack
              className="m-10 mr24"
              onClick={backLocation}
            />
            <Caption className="fxUnset@m">Invoice details</Caption>
            <div className="rlv ml20 pt14 ph20 pb13 r9">
              <span className={`f12 fw7 lh17 cFFBF43.pending c2CE889.paid ${status}`}>
                Invoice {status}
              </span>
              <div
                className={`w h abs slt o12 r9 bgFFBF43.pending bg2CE889.paid ${status}`}
              />
            </div>
          </div>
          {/* <div className="layoutRow aiC mt20@m">*/}
          {/*  <div className="ml36 ml0@m">*/}
          {/*    <ButtonPrintA*/}
          {/*      onClick={() => console.log('Start printing')}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*  <div className="ml36">*/}
          {/*    <DownloadA*/}
          {/*      onClick={() => console.log('Start download')}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/* </div>*/}
        </div>
        <div className="layoutRow aiFE mt29">
          <div className="w184">
            <span className="mt4 f16 fw6 lh18">Retailer name</span>
            <div className="mt4 f12 fw3 lh18 c717275">
              {state.account.name}
            </div>
          </div>
          <div className="ml29">
            <div className="mt4 f12 fw3 lh18 c717275">
              {state.account.login}
            </div>
          </div>
        </div>
        <div className="h1 bgDADCE1 mt50 mb46 mt36@m mb16@m" />
        <DataDisplay data={state.data} />
        <div className="mt71">
          <QuotesTable data={data.quotes || []} />
        </div>
        {/* <div className="layoutRow">*/}
        {/*  <div className="w268 mt34 mr64">*/}
        {/*    <Button onClick={backLocation}>*/}
        {/*      Back*/}
        {/*    </Button>*/}
        {/*  </div>*/}
        {/*  /!*{status === 'pending'*!/*/}
        {/*  /!*  ? (*!/*/}
        {/*  /!*    <div className="w268 mt34 mr64">*!/*/}
        {/*  /!*      <Button onClick={() => console.log('click')}>*!/*/}
        {/*  /!*        MARK as paid*!/*/}
        {/*  /!*      </Button>*!/*/}
        {/*  /!*    </div>*!/*/}
        {/*  /!*  ) : null*!/*/}
        {/*  /!*}*!/*/}
        {/* </div>*/}
      </WrapperWithLoading>
    );
  };
}, {
  account: account$,
});
